import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'brands_selection',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    goodsList: function goodsList() {
      var _this$value$config$br = this.value.config.brandList,
        brandList = _this$value$config$br === void 0 ? [] : _this$value$config$br;
      return brandList.slice(0, 4);
    }
  }
};